const INITIAL_STATE = { products: [] };

const reducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'ADD_PRODUCT':
            return { products: [...state.products, action.payload] };
        case 'REMOVE_PRODUCT':
            const filteredProducts = state.products.filter(
                ({ index }) => index !== action.payload
            );
            return { ...state, products: filteredProducts };
        case 'REMOVE_ALL_PRODUCTS':
            return (state = INITIAL_STATE);
        default:
            return state;
    }
};

export default reducer;
